export const ReactionType = {
    LIKE: "ReactionType.LIKE",
    HEART: "ReactionType.HEART",
    IDEA: "ReactionType.IDEA",
    CLAP: "ReactionType.CLAP",
    FUNNY: "ReactionType.FUNNY",
    SAD: "ReactionType.SAD"
};